import type { CommonStore } from './interfaces'

export const actions = {
  setLoading (this: CommonStore, payload: CommonStore['loading']): void {
    this.loading = payload
  },
  setInformationBanner (this: CommonStore, payload: CommonStore['informationBanner']): void {
    this.informationBanner = payload
  },
  setNoScroll (this: CommonStore, val: boolean): void {
    this.noScroll = val
  },
  setModalShowed (this: CommonStore, val: boolean): void {
    this.modalShowed = val
  },
}
